import React from 'react';
import '../../assets/scss/custom.css';



import { Link } from 'react-router-dom';
import {
    MdPhoneIphone,
    MdWeb,
    MdAccountBalance,
    MdCloud,
    MdStorage,
    MdDesktopMac
} from 'react-icons/md';

const serviceData = [
    {
        icon: MdPhoneIphone,
        title: "       Mobile Development",
        serviceKey: "mobile",
        description: "Transform your business with cutting-edge mobile solutions. Our expert team delivers enterprise-grade applications that combine stunning design with AI-driven functionality. From native apps to agent-enabled cross-platform solutions, we ensure your mobile presence drives real business value and exceptional user experiences.",
    },
    {
        icon: MdWeb,
        title: "        Web Development",
        serviceKey: "web",
        description: "Launch your digital presence with our enterprise-ready web development services. We build scalable, AI-enhanced web applications that grow with your business. Our prompt-engineered solutions combine modern architecture with robust security, ensuring your platform delivers consistent value to your customers.",
    },
    {
        icon: MdAccountBalance,
        title: "        Quickbooks Support",
        serviceKey: "quickbooks",
        description: "Streamline your financial operations with our comprehensive QuickBooks expertise. Our certified consultants provide end-to-end support for setup, optimization, and AI-assisted troubleshooting. We ensure your financial systems run smoothly, allowing you to focus on growing your business.",
    },
    {
        icon: MdCloud,
        title: "        IaaS",
        serviceKey: "iaas",
        description: "Leverage the power of Infrastructure as a Service with our enterprise-grade, AI-ready cloud solutions. We design, implement, and manage scalable infrastructure that adapts to your business needs. Our IaaS solutions provide the flexibility and reliability your organization demands.",
    },
    {
        icon: MdStorage,
        title: "         Enterprise Cloud",
        serviceKey: "cloud",
        description: "Accelerate your digital transformation with our comprehensive enterprise cloud services. We architect and deploy robust, agent-enabled cloud solutions that enhance operational efficiency, reduce costs, and drive AI-powered innovation. Our expertise ensures seamless migration and optimal performance.",
    },
    {
        icon: MdDesktopMac,
        title: "       Desktop Support",
        serviceKey: "desktop",
        description: "Maximize productivity with our responsive, AI-augmented desktop support services. Our experienced team uses intelligent diagnostics to provide rapid resolution for all your technical challenges, ensuring minimal downtime and optimal performance. We keep your systems running smoothly so you can focus on what matters most.",
    }
];

const ServicePropOne = ({ colSize, serviceStyle, itemShow, marginTop, onServiceClick }) => {
    const topMargin = (index) => {
        if (marginTop === "yes") {
            if (index === 0) return "mt--200 mt_md--0";
            if (index === 1) return "mt--100 mt_md--0";
            return "mt--0";
        }
        return "";
    };

    const handleServiceClick = (e, serviceKey) => {
        e.preventDefault();
        if (onServiceClick) {
            onServiceClick(serviceKey);
        }
    };

    return (
        <>
            {serviceData.slice(0, itemShow).map((data, index) => (
                <div className={`${colSize} ${topMargin(index)}`} key={index}>
                    <div 
                        className={`services-grid ${serviceStyle}`}
                        onClick={(e) => handleServiceClick(e, data.serviceKey)}
                        style={{ cursor: 'pointer' }}
                    >
                        <div className="content">
                            <div className="flex items-center space-x-4 mb-2">
                                <data.icon size={64} className="text-primary" />
                                <Link
                                    to={`/service-details/${data.title.toLowerCase().replace(/\s+/g, '-')}`}
                                    onClick={(e) => handleServiceClick(e, data.serviceKey)}
                                    className="text-lg bh-link hover:underline inline-block"
                                    style={{ lineHeight: '1.25', margin: 0, marginLeft: '18px'  }}
                                >
                                    {data.title}
                                </Link>
                            </div>

                            <p>{data.description}</p>
                        </div>
                    </div>
                </div>
            ))}
        </>
    );
};

export default ServicePropOne;
